import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

function Toast({ isVisible = false, message = "", className = "", ...rest }) {
  return (
    isVisible && (
      // custom css animation (named: fade-right), see in tailwind config.
      <div
        {...rest}
        className={clsx(
          "text-12px fixed bg-secondary right-[-380px] top-[140px] lg:top-[200px] z-[999] w-max border-b-2 border-primary py-[12px] px-[16px] animate-fade-right hidden",
          className,
          isVisible && "!block",
        )}
      >
        <span className="opacity-70">{message}</span>
      </div>
    )
  );
}

export default Toast;

Toast.propTypes = {
  isVisible: PropTypes.bool,
  message: PropTypes.string,
};
